import React, { FC, useCallback, useContext, useEffect, useState } from 'react';
import _, { find, flatten, isEmpty, isUndefined, map } from 'lodash';
import 'react-image-crop/dist/ReactCrop.css';
import './CustomImage.scss';
import { ImageTagger } from './ImageTagger';
import { ProductPopUpActionItem } from './ActionItem/ProductPopUp/ProductPopUpActionItem';
import { FlipbookCartContext } from '../../Hooks/FlipbookCartContext';
import { FlipbookLayoutTile } from '../../../../models/FlipbookV2/FlipbookV2LayoutTile.model';
import { ActionState } from '../../../../models/FlipbookV2/TileData/TileDataImage.model';
import { getStockItems } from '../../../../services/ecomCart.service';
import { setProductsWithStockItems } from '../../Utiles/FlipbookUtiles';
import { BusinessUnitContext } from '../../../OfferDefinition/BusinessUnitContext';
import { UserContext } from '../../../../hooks/UserContext';
import ProductService from '../../../../services/productMaster.service';
import { FlipbookContext } from '../../Hooks/FlipbookContext';
import { FlipbookProductsContext } from '../../Hooks/FlipbookProductsContext';

interface ViewComponentProps {
  flipbookLayoutTile: FlipbookLayoutTile | null;
}

export const ViewComponent: FC<ViewComponentProps> = ({
  flipbookLayoutTile
}) => {
  const [image, setImage] = useState('');
  const [mapArea, setMapArea] = useState<any[]>([]);
  const [currentTileProducts, setCurrentTileProducts] = useState<any[]>();
  const [isProductPopUpOpen, setIsProductPopUpOpen] = useState(false);
  const [isStockLoaded, setIsStockLoaded] = useState(false);
  const [actionItemData, setActionItemData] = useState<any>();
  const businessUnitContext = useContext(BusinessUnitContext);
  const businessId = businessUnitContext.business.id;
  const userInfo = useContext(UserContext);
  const flipbookCartContext = useContext(FlipbookCartContext);
  const flipbookContext = useContext(FlipbookContext);
  const isCustomerView = flipbookContext?.flipbookContext?.isCustomerView;
  const flipbookToken = flipbookContext.flipbookContext?.flipbookToken || '';
  const storeCode = flipbookCartContext.storeCode;
  const isSplitShipment =
    businessUnitContext.business?.flipbookConfig?.isSplitShipment || false;
  const { setProducts, setSkus, flipbookPages } = useContext(
    FlipbookProductsContext
  );

  const tenantName =
    _.get(userInfo, 'userInfo.esKey') ||
    _.get(userInfo, 'userInfo.tenant.esKey');
  const getImageFromTile = useCallback(() => {
    return _.get(flipbookLayoutTile, `tileData.imageData.URL`);
  }, [flipbookLayoutTile]);

  const getMapAreaFromTile = useCallback(() => {
    return _.get(flipbookLayoutTile, `tileData.imageData.mapArea`, []);
  }, [flipbookLayoutTile]);

  const getSKUsFromMapArea = useCallback((mapAreas: any) => {
    const listOfSkus = map(mapAreas, mapArea => {
      return mapArea.actionState === 'SKU' ? mapArea.actionItem : [];
    });
    return flatten(listOfSkus);
  }, []);
  const updateProductDataWithStock = useCallback(
    (result: any, arrayOfSkus: any) => {
      if (isEmpty(result) || isUndefined(businessId)) {
        return;
      }
      getStockItems(tenantName, businessId, storeCode, arrayOfSkus).then(
        stockItems => {
          const updatedProducts = setProductsWithStockItems(
            result,
            stockItems,
            isSplitShipment
          );
          setIsStockLoaded(true);
          setCurrentTileProducts(updatedProducts);
        },
        err => {
          setIsStockLoaded(true);
          setCurrentTileProducts(
            setProductsWithStockItems(result, [], isSplitShipment)
          );
        }
      );
    },
    [isSplitShipment, businessId, tenantName, storeCode]
  );
  useEffect(() => {
    const isSessionActivated = flipbookCartContext.isSessionActivated;
    const newImage = getImageFromTile();
    let newMapArea = getMapAreaFromTile();
    newMapArea = newMapArea || [];
    setMapArea(newMapArea);
    setImage(newImage);
    const listOfSkus = getSKUsFromMapArea(newMapArea);
    if (isCustomerView && (!isSessionActivated || isEmpty(storeCode))) {
      return;
    }
    if (
      !isEmpty(listOfSkus) &&
      !_.isEmpty(flipbookLayoutTile) &&
      !isEmpty(flipbookPages) &&
      businessId !== 0
    ) {
      setCurrentTileProducts(listOfSkus);
      if (isCustomerView) {
        ProductService.listProductsBySkuAndToken(
          flipbookToken,
          listOfSkus
        ).then(result => {
          setProducts((prevProducts: any) => [
            ...prevProducts,
            ...flatten([result])
          ]);
          setSkus((prevSkus: any) => [...prevSkus, ...listOfSkus]);
          updateProductDataWithStock(result, listOfSkus);
        });
      } else {
        !isUndefined(businessId) &&
          ProductService.listProductsBySku(listOfSkus, businessId).then(
            result => {
              setProducts((prevProducts: any) => [
                ...prevProducts,
                ...flatten([result])
              ]);
              setSkus((prevSkus: any) => [...prevSkus, ...listOfSkus]);
              updateProductDataWithStock(result, listOfSkus);
            }
          );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    image,
    flipbookLayoutTile,
    getImageFromTile,
    getMapAreaFromTile,
    getSKUsFromMapArea,
    storeCode,
    isCustomerView,
    flipbookToken,
    updateProductDataWithStock,
    flipbookCartContext.isSessionActivated,
    businessId,
    flipbookPages
  ]);
  const isActionItemEmpty = (area: any) => {
    return _.isEmpty(area.actionItem);
  };
  const openProductCardPopUp = (data: any) => {
    const dataPayload = find(
      currentTileProducts,
      product => product?.extendedData?.sku === data
    );
    setActionItemData(dataPayload);
    setIsProductPopUpOpen(true);
  };
  const performActionOnClick = (area: any) => {
    if (isActionItemEmpty(area)) {
      return;
    }
    const actionType = _.get(area, 'actionState', '');
    switch (actionType) {
      case ActionState.URL:
        window.open(area.actionItem, '_blank');
        break;
      case ActionState.SKU:
        openProductCardPopUp(area.actionItem);
        break;
      default:
        return '';
    }
  };
  return (
    <div className={'flipbook-map-box-edit-image'}>
      <ProductPopUpActionItem
        allProducts={actionItemData}
        setIsProductPopUpOpen={setIsProductPopUpOpen}
        isProductPopUpOpen={isProductPopUpOpen}
        cartItems={flipbookCartContext.cartItems}
        setCartItems={flipbookCartContext.setCartItems}
        setActionItemData={e => setActionItemData(e)}
        isStockLoaded={isStockLoaded}
      />

      <div style={{ width: '100%', height: '100%' }}>
        <img
          style={{ width: '100%', height: '100%' }}
          src={image}
          alt={'brochure'}
        />
      </div>
      <ImageTagger
        mapArea={mapArea}
        screenType={'View'}
        onClickArea={(area, index) => {
          performActionOnClick(area);
        }}
      />
    </div>
  );
};
